export const downloadJasperFile=(uri)=>{
    console.log('Dowloading Jasper File');
    setTimeout(() => {
        const response = {
            file: uri
        };
        window.location.href = response.file;
    }, 100);

}